import React from 'react';
interface Props {
	fill?: string;
	className?: string;
	width?: string;
	height?: string;
	filledColor?: string;
}
export function ForwardFractalCarousel(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			viewBox='0 0 59 59'
			style={{
				margin: '-5px 0px 0px -8px',
				boxShadow: '0 4px 8px 0 rgba(0,0,0,0.28)',
				borderRadius: '50%',
			}}
		>
			<g id='Fw-btn' transform='translate(0.089 0.089)'>
				<circle
					id='Ellipse_1221'
					data-name='Ellipse 1221'
					cx='29.5'
					cy='29.5'
					r='29.5'
					transform='translate(-0.089 -0.089)'
					fill={props.filledColor}
				/>

				<path
					id='Icon_ionic-ios-arrow-forward'
					data-name='Icon ionic-ios-arrow-forward'
					d='M23.114,21.048,11.87,9.812a2.114,2.114,0,0,1,0-3,2.141,2.141,0,0,1,3.008,0L27.617,19.544a2.12,2.12,0,0,1,.062,2.928L14.887,35.291a2.124,2.124,0,0,1-3.008-3Z'
					transform='translate(10.023 8.106)'
					fill={props.fill}
				/>
			</g>
		</svg>
	);
}

export function BackwardFractalCarousel(props: Props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={props.width ? props.width : '32'}
			height={props.height ? props.height : '32'}
			viewBox='0 0 59 59'
			style={{
				margin: '-5px 0px 0px -8px',
				boxShadow: '0 4px 8px 0 rgba(0,0,0,0.28)',
				borderRadius: '50%',
			}}
		>
			<g id='Fw-btn' transform='translate(0 0)'>
				<circle
					id='Ellipse_1221'
					data-name='Ellipse 1221'
					cx='29.5'
					cy='29.5'
					r='29.5'
					transform='translate(0 0)'
					fill={props.filledColor}
				/>

				<path
					id='Icon_ionic-ios-arrow-forward'
					data-name='Icon ionic-ios-arrow-forward'
					d='M16.368,21.048,27.612,9.812a2.114,2.114,0,0,0,0-3,2.141,2.141,0,0,0-3.008,0L11.865,19.544a2.12,2.12,0,0,0-.062,2.928L24.6,35.291a2.124,2.124,0,0,0,3.008-3Z'
					transform='translate(9.405 8.195)'
					fill={props.fill}
				/>
			</g>
		</svg>
	);
}
